import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * DrawerToggleButton - Button to expand/collapse the left panel drawer
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isDrawerExpanded - Whether the drawer is currently expanded
 * @param {boolean} props.isHovering - Whether the mouse is hovering over the drawer
 * @param {Function} props.onToggle - Function to handle toggle action
 * @returns {JSX.Element} Rendered toggle button
 */
const DrawerToggleButton = React.memo(({ 
  isDrawerExpanded, 
  isHovering, 
  onToggle 
}) => {
  return (
    <Tooltip title={isDrawerExpanded ? 'Collapse' : 'Expand'}>
      <IconButton
        sx={{
          position: 'absolute',
          left: isDrawerExpanded ? 256 : 48,
          bottom: '5%',
          transform: 'translateY(-50%)',
          zIndex: 1200,
          background: 'white',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          transition: 'left 0.2s ease',
          flexShrink: 0,
          height: '45px',
          padding: '5px 10px',
          display: isHovering && !isDrawerExpanded ? 'none' : 'flex',
        }}
        onClick={onToggle}
      >
        {isDrawerExpanded ? <ArrowBackIcon /> : <ArrowForwardIcon />}
      </IconButton>
    </Tooltip>
  );
});

export default DrawerToggleButton; 